import React from 'react';
import Icon from '../../../components/AppIcon';

const MeetingControls = ({
  isMuted,
  isVideoOff,
  isScreenSharing,
  showChat,
  onToggleMute,
  onToggleVideo,
  onToggleScreenShare,
  onToggleChat,
  onEndCall
}) => {
  const ControlButton = ({ icon, label, active = false, danger = false, onClick, badge = false }) => (
    <button
      onClick={onClick}
      className={`flex flex-col items-center gap-1 px-4 py-3 rounded-xl transition-all ${
        danger
          ? 'bg-red-600 hover:bg-red-700 text-white'
          : active
          ? 'bg-blue-600 text-white' :'bg-[#374151] hover:bg-[#4B5563] text-gray-300'
      }`}
      aria-label={label}
    >
      <div className="relative">
        <Icon name={icon} size={24} />
        {badge && (
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full" />
        )}
      </div>
      <span className="text-xs font-medium hidden sm:block">{label}</span>
    </button>
  );

  return (
    <div className="flex items-center justify-center gap-3">
      <ControlButton
        icon={isMuted ? 'MicOff' : 'Mic'}
        label={isMuted ? 'Unmute' : 'Mute'}
        active={!isMuted}
        onClick={onToggleMute}
      />

      <ControlButton
        icon={isVideoOff ? 'VideoOff' : 'Video'}
        label={isVideoOff ? 'Start Video' : 'Stop Video'}
        active={!isVideoOff}
        onClick={onToggleVideo}
      />

      <ControlButton
        icon="Monitor"
        label={isScreenSharing ? 'Stop Sharing' : 'Share Screen'}
        active={isScreenSharing}
        onClick={onToggleScreenShare}
      />

      <ControlButton
        icon="MessageSquare"
        label="Chat"
        active={showChat}
        onClick={onToggleChat}
      />

      <div className="w-px h-10 bg-[#4B5563] mx-2" />

      <ControlButton
        icon="PhoneOff"
        label="End Call"
        danger
        onClick={onEndCall}
      />
    </div>
  );
};

export default MeetingControls;